import axios from "axios";

const api = axios.create({
  // baseURL: "http://localhost/backend_inv",
  // baseURL: "http://192.168.150.151/backend_inv",
  baseURL: "https://patlasp.id/backend_inv",
});

const getToken = () =>
  localStorage.getItem("token") || sessionStorage.getItem("token");
const getTahun = () =>
  localStorage.getItem("tahun") || sessionStorage.getItem("tahun");

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    const tahun = getTahun();

    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (tahun) config.headers["X-Tahun"] = tahun; // 👈 penting

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      [
        "token",
        "NIP",
        "username",
        "namaLengkap",
        "idUser",
        "idRole",
        "idDepartemen",
        "isActive",
        "tahun",
      ].forEach((k) => {
        localStorage.removeItem(k);
        sessionStorage.removeItem(k);
      });

      localStorage.setItem("expired", "1");

      // window.location.href = "/backend_inv/login";
      // Menjadi ini (agar kembali ke halaman login aplikasi React Anda):
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
